import domWrap from "../utils/domWrap";

export default async tabs => { // 'comp-tabs'
	const tabTargets = [...tabs.querySelectorAll('button')].reduce((map, button, index) => {
		const 	key = button.getAttribute('data-target'),
				element = domWrap(document.querySelector(key));
		element.classList.add('tab-content');
		if(index === 0) element.classList.add('expanded');
		return !key ? map : {
			...map,
			[key]: element
		};
	},{});
	domWrap(tabs).on('click','button',function(){
		const button = domWrap(this);
		button.setSelected('on');
		tabTargets[button.getAttribute('data-target')].setSelected('expanded');
	});
};